import { useCallback, useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { ModalButtonColor, ModalType, WalletType } from '~/shared';
import {
	setActiveListIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../redux';

const useBuy = () => {
	const dispatch = useLayoutDispatch();
	const activeList = useLayoutSelector((state) => state.tattooShop.activeList);
	const activeListIndex = useLayoutSelector(
		(state) => state.tattooShop.activeListIndex,
	);
	const activeCategory = useLayoutSelector(
		(state) => state.tattooShop.activeCategory,
	);
	const ownedTattoos = useObservable(rage.tattooShop.getOwnedTattoos());
	const tattooDeletionPrice = useObservable(
		rage.tattooShop.getTattooDeletionPrice(),
	);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const list = useMemo(() => {
		if (activeCategory === 'delete') {
			return ownedTattoos;
		}
		return activeList;
	}, [activeCategory, activeList, ownedTattoos]);

	const item = useMemo(
		() => list[activeListIndex || 0],
		[list, activeListIndex],
	);

	const handleBuy = useCallback(
		(walletType: WalletType) => {
			if (modalState) {
				return;
			}

			const text = `Вы действительно хотите оплатить ${
				walletType === WalletType.Cash ? 'наличными' : 'картой'
			} товар "${item.name}"`;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: text,
					price: item.price ?? 0,
					wallet: walletType,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result) => {
					if (result.isAccepted) {
						rage.tattooShop.buyTattoo(item.id, walletType);
						dispatch(setActiveListIndex(null));
					}
				},
			);
		},
		[item, modalState],
	);

	const handleDelete = useCallback(
		(walletType: WalletType) => {
			const text = `Вы действительно хотите удалить тату "${item.name}"?`;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: text,
					price: tattooDeletionPrice,
					wallet: walletType,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result) => {
					if (result.isAccepted) {
						rage.tattooShop.deleteTattoo(item.id, walletType);
						dispatch(setActiveListIndex(null));
					}
				},
			);
		},
		[item, tattooDeletionPrice],
	);

	return { handleBuy, handleDelete };
};

export { useBuy };
